import { FixedLayout } from '@vkontakte/vkui';
import { useEffect, useRef, type ReactNode } from 'react';
import styles from './ui.module.css';

/** Имя переменной с ростом полосы: по ней распорка держит место в ленте. */
const HEIGHT_VAR = '--meza-form-footer-height';

/**
 * Прикреплённая полоса действий формы.
 *
 * В макетах она не уезжает вместе с текстом: экран редактора длинный, и
 * кнопка «отправить» должна быть под рукой на любом поле, а не в конце ленты.
 * Отбита чертой с глухой подложкой — тем же приёмом, что и таббар.
 *
 * Прикрепляет её вкуишный `FixedLayout`: он держит безопасные поля и считает
 * место над таббаром. Своё здесь только оформление полосы.
 *
 * Свой рост полоса ОБЪЯВЛЯЕТ переменной, а не подбирается числом: у неё две
 * формы — одна кнопка с подписью и две кнопки с подписью, — и разница между
 * ними в полтора десятка пикселей. Фиксированная распорка в 104 px под второй
 * формой не хватала, и последнее поле уходило под кнопки.
 */
export function FormFooter({ children }: { children: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const node = ref.current;
    if (node === null) return undefined;

    const publish = () => {
      document.documentElement.style.setProperty(HEIGHT_VAR, `${node.offsetHeight}px`);
    };

    publish();
    const observer = new ResizeObserver(publish);
    observer.observe(node);

    return () => {
      observer.disconnect();
      document.documentElement.style.removeProperty(HEIGHT_VAR);
    };
  }, []);

  return (
    <FixedLayout vertical="bottom">
      <div className={styles.formFooter} ref={ref}>
        {children}
      </div>
    </FixedLayout>
  );
}

/**
 * Распорка в конце ленты: место под прикреплённую полосу и просвет над ней.
 *
 * Без неё последнее поле уходит под полосу — прикреплённый элемент из потока
 * выключен, и лента о нём не знает.
 */
export function FormFooterSpacer() {
  return <div className={styles.formFooterSpacer} />;
}
